<template>
  <div :class="$style.tagplayContainer">
    <div id="tagplay-widget-1c6bd9" class="tagplay-widget" data-project="04d7b70a-aaa4-4c51-9c0b-78f12c0c98ce" data-feed="1c6bd967-1cd7-4be7-a512-ad651683f011"
      data-token="eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJlbWFpbCI6ImVpbmFyQHNpbGZyYS5pcyIsImFwaV9rZXkiOiJhOGJkY2NmNmE0NWUzMWI4MTA1NzY0ZGQyMjYwNmZkZTMxNzYwNjRlIiwiZmVlZElkIjoiMWM2YmQ5NjctMWNkNy00YmU3LWE1MTItYWQ2NTE2ODNmMDExIiwiaWF0IjoxNDk0NDIzMTg1fQ.AZz4jX968CTcL25Ir_59P1flaSgmc0qzuIbTW7HgAMI"
      data-include-usernames data-include-captions data-include-link-metadata data-rows="120" :data-cols="cols" data-spacing="10" data-hashtags="show"
      data-style="minimal" data-type="grid" data-responsive data-lightbox data-trigger-tags="góðarsögur,godarsogur" data-num-media="360"
      data-client="[object Object]"></div>
    </div>

</template>


<script>
import styles from '../styles/TagplayCustom.styl';
export default {
  props: ['cols'],
  name: 'taplayWidget',
  mounted() {
    var widgetElement = document.getElementById('tagplay-widget-1c6bd9');
    if (typeof TagplayWidget === 'function') {
      TagplayWidget(widgetElement);
    } else {
      if (!window.tagplayWidgetQueue) window.tagplayWidgetQueue = [];
      window.tagplayWidgetQueue.push(widgetElement);
    }
  }
};
</script>

<style lang="stylus" module src="../styles/TagplayWidget.styl"></style>



// WEBPACK FOOTER //
// TagplayWidget.vue?1e114d22